import { _addonUrls } from '@custom/Utils/constants/apiUrls';
import { createAsyncThunk } from '@reduxjs/toolkit';

// Async thunk to add a teleradiology customer
export const getAddons = createAsyncThunk(
  'getAddons',
  async (_, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const response = await fetch(_addonUrls.get, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        return rejectWithValue('Failed to get plans');
      }

      const data = await response.json();

      return data; // Return the response data if successful
    } catch (error: any) {
      return rejectWithValue(error.message); // Handle any errors that occur
    }
  }
);
